import { useQuery } from '@hooks/reactQuery';

import { portalTimeline } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getPortalTimeline } from '@api/portalTimeline';

import { extractQueryParams } from '@utils/common';

import { IPortalTimelineDTO } from '@interfaces/portal/dto/timelineManagementDTO';
import { IPortalTimelineMilestoneWithTasks, IPortalTimelineTask } from '@interfaces/portal/timeline';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_TIMELINE } from '@constants/queryKeys';

interface IUseQueryPortalTimelineReturned {
	isLoadingPortalTimeline: boolean;
	portalTimelineMilestonesWithTasks: IPortalTimelineMilestoneWithTasks[];
	portalTimelineTasksWithoutMilestones: IPortalTimelineTask[];
}

export const useQueryPortalTimeline = (projectId?: string): IUseQueryPortalTimelineReturned => {
	const {
		searchValue,
		sortFieldName,
		sortDirection,
		status,
		priority,
		milestoneId,
		assignees,
	} = useAppSelector(portalTimeline);

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IPortalTimelineDTO>({
			queryKey: [
				GET_PORTAL_TIMELINE,
				{
					searchValue,
					sortFieldName,
					sortDirection,
					status,
					priority,
					projectId,
					milestoneId,
					assignees,
				},
			],
			queryFn: extractQueryParams(getPortalTimeline),
			enabled: [!!projectId],
			...refetchOptions,
		},
	);

	return {
		isLoadingPortalTimeline: isLoading || isFetching,
		portalTimelineMilestonesWithTasks: data?.milestonesWithTasks || [],
		portalTimelineTasksWithoutMilestones: data?.tasksWithoutMilestones || [],
	};
};
